import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Truckload } from '../data/componentsConnection';

export interface PackingState {
  readonly truckloads: readonly Truckload[];
  readonly displayedTruckloadIndex: number;
}

const initialState: PackingState = { truckloads: [], displayedTruckloadIndex: 0 };

const packingSlice = createSlice({
  name: 'packing',
  initialState,
  reducers: {
    loadTruckloads: (state, action: PayloadAction<readonly Truckload[]>) => {
      state.truckloads = castDraft(action.payload);
      state.displayedTruckloadIndex = 0;
    },
    setDisplayedTruckload: (state, action: PayloadAction<number>) => {
      state.displayedTruckloadIndex = action.payload;
    },
  },
});

export const { loadTruckloads, setDisplayedTruckload } = packingSlice.actions;
export const packing = packingSlice.reducer;
